import type { NskResponse } from "~/models/Api";
import type {
	BillingBulkUpdateContext,
	BillingType
} from "~/models/DealBilling";
import { postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/deals/:deal_id/deal_billing_updates"
};

export const postUpdate = async (
	billingUpdateContext: BillingBulkUpdateContext | null,
	dealId: number,
	billingType: BillingType
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		billingType,
		billingUpdateContext
	});
